var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00004 0C9.49707 0 9.9 0.402926 9.9 0.899961L9.9 8.1L17.1 8.10005C17.5971 8.10005 18 8.50297 18 9C18 9.49703 17.5971 9.89995 17.1 9.89995L9.9 9.899L9.9 17.1001C9.9 17.5972 9.49707 18.0001 9.00004 18.0001C8.503 18.0001 8.10008 17.5972 8.10008 17.1001L8.1 9.899L0.899951 9.89995C0.402922 9.89995 0 9.49703 0 9C0 8.50297 0.402922 8.10005 0.899951 8.10005L8.1 8.1L8.10008 0.899961C8.10008 0.402926 8.503 0 9.00004 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.5ade236828104c0e95823c5ddadffc0a.svg";
export { ForwardRef as ReactComponent };